import { LegacyTvChannelPlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useReadPlayerBaseInfo } from '@/scenarios/legacy-player/components/player-manager/hooks/use-read-player-base-info';

export function useReadChannelPlayerBaseInfo(
    contentId: string
): LegacyTvChannelPlayerBaseInfoContent | null {
    const data = useReadPlayerBaseInfo(contentId);

    if (data?.content?.__typename === 'TvChannel') {
        return data.content;
    }

    return null;
}
